// extracted by mini-css-extract-plugin
export default {"h3styles":"index_h3styles__ieyxY"};